import { render } from "./BasicAccordion.vue?vue&type=template&id=7f07d6c8"
import script from "./BasicAccordion.vue?vue&type=script&lang=js"
export * from "./BasicAccordion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__